<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">货品管理</el-breadcrumb-item>
        <el-breadcrumb-item>金料单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-form :model="query" ref="query" label-width="90px" class="search-form">
      <el-row>
        <el-form-item label="关键词" prop="keyword">
          <el-col style="width: 150px">
            <el-input v-model="query.keyword" @keyup.enter="fetchs()" prefix-icon="Search"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item v-if="showOrgFilters" label="所属公司">
          <el-col>
            <!-- <el-cascader v-model="companyId" :options="companys" clearable @change="fetchs" /> -->
            <el-tree-select ref="companys" v-model="companyId" :data="companys" @change="companyChange();"
              check-strictly :render-after-expand="false" style="min-width: 210px;" />
          </el-col>
        </el-form-item>
        <el-form-item label="所属部门">
          <el-col>
            <el-tree-select ref="departments" v-model="departmentId" :data="departments" clearable check-strictly
              @change="fetchs()" :render-after-expand="false" style="min-width:120px" />
          </el-col>
        </el-form-item>
        <el-form-item label="所属工厂">
          <el-col>
            <el-select v-model="factoryCode" placeholder="请选择工厂信息" filterable @change="fetchs()">
              <el-option v-for="item in factorys" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="单据时间">
          <el-col>
            <el-date-picker v-model="dateRange" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"
              unlink-panels :shortcuts="$util.getShortCuts()" @change="fetchs()" style="max-width:210px;">
            </el-date-picker>
          </el-col>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="操作类型" prop="billType">
          <el-col>
            <el-select v-model="billType" placeholder="请选择操作类型" clearable @change="fetchs()" style="width: 150px">
              <el-option v-for="item in dict.billTypes" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="是否最新" prop="remainMark">
          <el-col>
            <el-select v-model="remainMark" placeholder="请选择" @change="fetchs()" clearable style="width: 150px">
              <el-option key="历史数据" label="历史数据" value="0"></el-option>
              <el-option key="最新数据" label="最新数据" value="1"></el-option>
              <el-option key="待审核损益单" label="待审核损益单" value="20"></el-option>
              <el-option key="已审核损益单" label="已审核损益单" value="21"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="单据状态" prop="status">
          <el-col>
            <el-select v-model="status" placeholder="请选择单据状态" @change="fetchs" clearable style="width: 150px">
              <el-option key="待确认" label="待确认" value="0"></el-option>
              <el-option key="已审核" label="已审核" value="1"></el-option>
              <el-option key="已取消" label="已取消" value="-1"></el-option>
            </el-select>
          </el-col>
        </el-form-item> -->

        <el-form-item label="" label-width="20px">
          <el-button type="primary" icon="Search" @click="fetchs()">
            搜索
          </el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="toolbar">
      <el-button type="primary" icon="download" @click="exportEvent()">明细导出</el-button>
    </div>

    <basic-table ref="table" class="table" :query="query" @handler="fetchs()">
      <template v-slot:status="scope">
        <el-link v-if="scope.row.status == 0" type="primary" size="small" disabled>待确认</el-link>
        <el-link v-else-if="scope.row.status == 10" type="primary" size="small" disabled>已入库</el-link>
        <el-link v-else-if="scope.row.status == 20" type="primary" size="small" disabled>已送出</el-link>
        <el-link v-else-if="scope.row.status == 50" type="success" size="small" disabled>已确认</el-link>
        <el-link v-else-if="scope.row.status == -1" type="danger" size="small" disabled>已取消</el-link>
        <el-link v-else type="info" size="small" disabled>其他</el-link>
      </template>
      <template v-slot:remainMark="scope">
        <el-link v-if="scope.row.remainMark == 0" type="primary" size="small" disabled>否</el-link>
        <el-link v-if="scope.row.remainMark == 1" type="success" size="small" disabled>
          是<span>{{ scope.row.remainNumber<0?'(欠料)':scope.row.remainNumber>0?'(结余)':'' }}</span>
        </el-link>

        <el-tooltip content="待审核的损益单" transition="slide-fade">
          <el-link v-if="scope.row.remainMark == 20" type="danger" size="small" disabled>损益</el-link>
        </el-tooltip>
        <el-tooltip content="已审核的损益单" transition="slide-fade">
          <el-link v-if="scope.row.remainMark == 21" type="success" size="small" disabled>损益</el-link><!-- 审核后的调整单 -->
        </el-tooltip>
      </template>

      <template v-slot:toolbar="scope">
        <el-link @click="watch(scope.row)" type="primary" size="small" style="margin:5px;">查看原始单据</el-link>
      </template>
    </basic-table>
  </el-card>
</template>

<script>
import { } from "@/api/stock";
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
export default {
  name: "StockMaterialDetail",
  components: { StaticDialog, BasicTable },
  data() {
    return {
      dateRange: [],
      query: {
        keyword: "",
        columns: [
          { type: "selection", width: "55" },
          { type: "index", label: "序号" },
          { prop: "billType", label: "单据类型", sortable: true, searchable: true, width: "90", showOverflowTooltip: true, },
          { prop: "billCode", label: "单据编号", sortable: true, searchable: true, width: "160", showOverflowTooltip: true, },
          { prop: "departmentName", label: "渠道部门", searchable: true, width: "100", showOverflowTooltip: true },
          { prop: "factoryName", label: "工厂", searchable: true, width: "170", showOverflowTooltip: true, permission: 3, },

          { prop: "materialName", label: "材质", sortable: true, searchable: true, width: "80", showOverflowTooltip: true, },
          { prop: "stockNumber", label: "操作数量", width: "75", },
          { prop: "unitPrice", label: "操作单价", width: "105", permission: 3, },
          { prop: "stockPrice", label: "操作总价", width: "85", },
          { prop: "stockDate", label: "操作时间", width: "150", sortable: true, showOverflowTooltip: true },

          { prop: "remainNumber", label: "库存剩余数", width: "85", },
          { prop: "remainPrice", label: "库存总价", width: "95", },
          { type: "template", prop: "status", label: "状态", width: "70", searchable: true, },
          { type: "template", prop: "remainMark", label: "最新?", width: "70", searchable: true, },

          { prop: "memo", label: "标记", sortable: true, searchable: true, width: "100", showOverflowTooltip: true, },
          { prop: "remark", label: "备注", searchable: true, width: "110", showOverflowTooltip: true },

          { prop: "createDate", label: "创建时间", width: "150", sortable: true, showOverflowTooltip: true },
          { prop: "createUserName", label: "创建人", sortable: true, searchable: true, width: "80", },
          { type: "toolbar", label: "操作", width: "140" },
        ],
        filters: [],
        sidx: "id",
        sord: "desc"
      },

      status: '',
      companys: [],
      companyId: '',
      departments: [],
      departmentId: '',
      factoryCode: '',
      factorys: [],

      billType: '',
      remainMark: '',
      dict: {
        billTypes: [],
      },
    };
  },
  mounted() {
    //kaung插件初始化
    this.$kaung.init(this.$options.name);

    this.$kaung.dictionary("stock", "material").then((res) => { this.dict.billTypes = res; });
    if (this.showOrgFilters) {
      this.$kaung.companys().then((res) => {
        this.companys = res;
        this.companyChange();
      });
    } else {
      this.companyId = '*';
      this.fetchs();
    }
  },
  methods: {
    fetchs(methodName) {
      if ((typeof methodName) == 'object') methodName = null;

      this.query.filters = [];
      if (this.billType) {
        this.query.filters.push({ name: "billType", value: this.billType, operate: 0, });
      }
      if (this.companyId) {
        this.query.filters.push({ name: "companyId", value: this.companyId, operate: 0, });
      }
      if (this.departmentId != null && this.departmentId.length > 0) {
        this.query.filters.push({ name: "departmentId", value: this.departmentId, operate: 6, });
      }
      if (this.status) {
        this.query.filters.push({ name: "status", value: this.status, operate: 0, });
      }
      if (this.remainMark) {
        this.query.filters.push({ name: "remainMark", value: this.remainMark, operate: 0, });
      }
      if (this.dateRange && this.dateRange[0]) {
        this.query.filters.push({ name: "billDate", value: this.$util.fmtDate(this.dateRange[0], "yyyy-MM-dd"), operate: 2 });
      }
      if (this.dateRange && this.dateRange[1]) {
        this.query.filters.push({ name: "billDate", value: this.$util.fmtDate(this.dateRange[1], "yyyy-MM-dd") + " 23:59:59", operate: 4 });
      }

      let { data, records, total, ...params } = { ...this.query };
      params.url = this.$options.name + '/' + (methodName || 'Search');
      this.$kaung.search(params).then((res) => {
        if (methodName == 'Export') {
          this.$notify({
            title: "导出成功",
            message: res.content,
            type: "success",
            duration: 10000
          });
          window.location.href = process.env.VUE_APP_BASEURL + res.data;
        }
        else {
          this.query = { ...res.data };
        }
      });
    },

    companyChange() {
      if (this.companyId) {
        this.departmentId = '';
        this.departments = [];
        var that = this;
        this.$kaung.departments(this.companyId).then((res) => {
          that.departments = res;
        });
      }
      this.fetchs();
    },
    watch(row) {
      this.$kaung.fetch({ url: 'StockMaterialBill/GetBillDto?id=' + row.billCode, method: 'get' })
        .then((res) => {
          let id = res.data.bill.id;
          if (row.billType.indexOf("采购") > -1)
            this.$router.push({ path: "stored", query: { id: id } });
          else if (row.billType.indexOf("送料") > -1)
            this.$router.push({ path: "dispatched", query: { id: id } });
          else if (row.billType.indexOf("回货") > -1)
            this.$router.push({ path: "received", query: { id: id } });
        });
    },

    exportEvent() {
      this.fetchs('Export');
    },
  },
  watch: {
    companyId: function (newValue, oldValue) {
      if (newValue && newValue != oldValue)
        this.$util.setLocalstorage('companyIdStr', newValue);
      else
        this.$util.setLocalstorage('companyIdStr', '');
    },
    billType: function (newValue, oldValue) {
      if (newValue != oldValue)
        this.$util.setPageCache('billType', newValue);
    },
    status: function (newValue, oldValue) {
      if (newValue != oldValue)
        this.$util.setPageCache('status', newValue);
    }
  },
  created: function () {
    this.$kaung.dictionary("stock", "factory").then((res) => { this.factorys = res.filter(q => !!q.value); });

    let companyIdStr = this.$util.getLocalstorage('companyIdStr');
    if (companyIdStr != '' && (this.companyId == null || this.companyId.length == 0)) {
      this.companyId = companyIdStr;
    }
    this.query.keyword = this.$util.getPageCache('keyword');
    this.billType = this.$util.getPageCache('billType') || "";
    this.status = this.$util.getPageCache('status');
  }
};
</script>

<style lang="less"></style>


